import { z } from 'zod';

export const reviewLaunchSchema = z.object({
  agreedToTerms: z.boolean().refine((value) => value, {
    message: 'You must agree to the terms and policies to launch the campaign',
  }),
});

export type ReviewLaunchFormValues = z.infer<typeof reviewLaunchSchema>;
